import React from "react";
import Switch from "react-switch";

export const CauHinhCamDoTinChap = ({
  data,
  handleInputChange,
  handleSelectAll,
  CustomCheckbox,
  CustomRadio,
}) => {
  const isAnyKyDongLaiEnabled =
    data.KyDongLaiNgayEnabled ||
    data.KyDongLaiTuanEnabled ||
    data.KyDongLaiThangEnabled ||
    data.KyDongLaiThangDinhKyEnabled;

  return (
    <div className="form-body custom-form-layout">
      <div className="form-group row">
        <label className="col-md-2 label-control">Hiển thị tính lãi</label>
        <div className="col-md-10">
          <div className="d-flex align-items-center">
            {CustomRadio && (
              <CustomRadio
                id="tinhLaiHienNgayTraGoc"
                name="OptionTinhLai"
                value={2}
                dataType="number"
                checked={data.OptionTinhLai === 2}
                onChange={handleInputChange}
                label="Ngày trả gốc"
                className="mb-0 mr-3"
              />
            )}
            {CustomRadio && (
              <CustomRadio
                id="tinhLaiHienSoLanTra"
                name="OptionTinhLai"
                value={3}
                dataType="number"
                checked={data.OptionTinhLai === 3}
                onChange={handleInputChange}
                label="Số lần trả"
                className="mb-0"
              />
            )}
          </div>
          {data.OptionTinhLai === 3 && (
            <div
              className="mt-1 d-flex align-items-center"
              style={{ paddingLeft: "1.5rem" }}
            >
              {CustomRadio && (
                <CustomRadio
                  id="lanTraLaiNhapSoLan"
                  name="IsTongSoNgay"
                  value="false"
                  checked={data.IsTongSoNgay === false}
                  onChange={(e) =>
                    handleInputChange({
                      target: {
                        name: "IsTongSoNgay",
                        value: false,
                        type: "radio",
                      },
                    })
                  }
                  label="Số lần trả lãi"
                  className="mb-0 mr-3"
                />
              )}
              {CustomRadio && (
                <CustomRadio
                  id="lanTraLaiNhapSoNgay"
                  name="IsTongSoNgay"
                  value="true"
                  checked={data.IsTongSoNgay === true}
                  onChange={(e) =>
                    handleInputChange({
                      target: {
                        name: "IsTongSoNgay",
                        value: true,
                        type: "radio",
                      },
                    })
                  }
                  label="Tổng số ngày trả lãi"
                  className="mb-0"
                />
              )}
            </div>
          )}
        </div>
      </div>

      <div className="form-group row">
        <label className="col-md-2 label-control">Phí kho</label>
        <div className="col-md-10">
          <Switch
            onChange={(checked) => {
              const value = checked ? 1 : 2;
              handleInputChange({
                target: {
                  name: "PhiKho",
                  value: value,
                  type: "radio",
                  dataset: { type: "number" },
                },
              });
            }}
            checked={data.PhiKho === 1}
            onColor="#28D094"
            offColor="#d9534f"
            height={24}
            width={50}
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-md-2 label-control">Số ngày tất toán</label>
        <div className="col-md-10 d-flex align-items-center">
          <Switch
            onChange={(checked) =>
              handleInputChange({
                target: {
                  name: "IsSoNgayTatToan",
                  checked: checked,
                  type: "checkbox",
                },
              })
            }
            checked={data.IsSoNgayTatToan}
            onColor="#28D094"
            offColor="#d9534f"
            height={24}
            width={50}
          />
          <div
            className="bordered-1 ms-2 p-2 d-flex align-items-center rounded"
            style={{ visibility: data.IsSoNgayTatToan ? "visible" : "hidden" }}
          >
            <label className="label-control me-2 mb-0 mr-1">
              Số ngày mặc định:
            </label>
            <input
              type="number"
              name="SoNgayMacDinhTatToan"
              className="form-control input-sm"
              value={data.SoNgayMacDinhTatToan}
              onChange={handleInputChange}
              style={{ width: "80px", marginRight: "12px" }}
            />
            {CustomCheckbox && (
              <CustomCheckbox
                id="choPhepSua"
                name="SuDungSoNgayMacDinhTatToan"
                checked={data.SuDungSoNgayMacDinhTatToan}
                onChange={handleInputChange}
                label="Cho phép sửa"
                className="mb-0 ms-3"
              />
            )}
          </div>
        </div>
      </div>
      <div className="form-group row">
        <label className="col-md-2 label-control">Gia hạn tự động</label>
        <div className="col-md-10">
          <Switch
            onChange={(checked) =>
              handleInputChange({
                target: {
                  name: "IsGiaHanTuDong",
                  checked: checked,
                  type: "checkbox",
                },
              })
            }
            checked={data.IsGiaHanTuDong}
            onColor="#28D094"
            offColor="#d9534f"
            height={24}
            width={50}
          />
        </div>
      </div>
      {data.IsCauHinhTatToanPhiHangKyCaKy === "1" && (
        <div className="form-group row">
          <label className="col-md-2 label-control">
            Tất toán cả kỳ với phí hàng kỳ
          </label>
          <div className="col-md-10">
            <Switch
              onChange={(checked) =>
                handleInputChange({
                  target: {
                    name: "CauHinhTatToanPhiHangKyCaKy",
                    checked: checked,
                    type: "checkbox",
                  },
                })
              }
              checked={data.CauHinhTatToanPhiHangKyCaKy}
              onColor="#28D094"
              offColor="#d9534f"
              height={24}
              width={50}
            />
          </div>
        </div>
      )}
      <div className="form-group row">
        <label className="col-md-2 label-control">
          Cách tính số ngày trả lãi
        </label>
        <div className="col-md-10 d-flex align-items-center">
          {CustomRadio && (
            <CustomRadio
              id="ngayTraTruNgayVay"
              name="CachTinhLai"
              value={1}
              dataType="number"
              checked={data.CachTinhLai === 1}
              onChange={handleInputChange}
              label="Ngày trả - Ngày vay"
              className="mb-0 mr-3"
            />
          )}
          {CustomRadio && (
            <CustomRadio
              id="ngayTraTruNgayVayCong1"
              name="CachTinhLai"
              value={2}
              dataType="number"
              checked={data.CachTinhLai === 2}
              onChange={handleInputChange}
              label="(Ngày trả - Ngày vay) + 1"
              className="mb-0"
            />
          )}
        </div>
      </div>

      <div className="form-group row">
        <label className="col-md-2 label-control">
          Cách tính ngày lãi vay thêm
        </label>
        <div className="col-md-10 d-flex align-items-center">
          {CustomRadio && (
            <CustomRadio
              id="ngayVayThem"
              name="NgayVayThemOption"
              value={0}
              dataType="number"
              checked={data.NgayVayThemOption === 0}
              onChange={handleInputChange}
              label="Ngày vay thêm"
              className="mb-0 mr-3"
            />
          )}
          {CustomRadio && (
            <CustomRadio
              id="ngayVayThemCong1"
              name="NgayVayThemOption"
              value={1}
              dataType="number"
              checked={data.NgayVayThemOption === 1}
              onChange={handleInputChange}
              label="Ngày vay thêm + 1"
              className="mb-0"
            />
          )}
        </div>
      </div>

      <div className="form-group row form-date-mm ky-dong-lai-section">
        <label className="col-md-2 label-control">Kỳ đóng lãi</label>
        <div className="col-md-10">
          {CustomCheckbox && (
            <CustomCheckbox
              id="chonTatCaKyDongLai"
              checked={
                data.KyDongLaiNgayEnabled &&
                data.KyDongLaiTuanEnabled &&
                data.KyDongLaiThangEnabled &&
                data.KyDongLaiThangDinhKyEnabled
              }
              onChange={handleSelectAll}
              label="Chọn tất cả"
            />
          )}
          <div
            className="d-flex flex-column flex-md-row config-container"
            style={{ marginTop: "1rem" }}
          >
            <div className="config-card flex-grow-1">
              <div className="config-card-header">DANH SÁCH</div>
              <div className="config-card-body">
                {CustomCheckbox && (
                  <CustomCheckbox
                    id="checkNgay"
                    name="KyDongLaiNgayEnabled"
                    checked={data.KyDongLaiNgayEnabled}
                    onChange={handleInputChange}
                    label="Ngày"
                  />
                )}
                {CustomCheckbox && (
                  <CustomCheckbox
                    id="checkTuan"
                    name="KyDongLaiTuanEnabled"
                    checked={data.KyDongLaiTuanEnabled}
                    onChange={handleInputChange}
                    label="Tuần"
                  />
                )}
                {CustomCheckbox && (
                  <CustomCheckbox
                    id="checkThang"
                    name="KyDongLaiThangEnabled"
                    checked={data.KyDongLaiThangEnabled}
                    onChange={handleInputChange}
                    label="Tháng"
                  />
                )}
                {CustomCheckbox && (
                  <CustomCheckbox
                    id="checkThangDinhKy"
                    name="KyDongLaiThangDinhKyEnabled"
                    checked={data.KyDongLaiThangDinhKyEnabled}
                    onChange={handleInputChange}
                    label="Tháng định kỳ"
                  />
                )}
              </div>
            </div>
            <div className="config-card flex-grow-1">
              <div className="config-card-header">NHÃN ĐƯỢC CHỌN</div>
              <div className="config-card-body">
                {CustomRadio && data.KyDongLaiNgayEnabled && (
                  <CustomRadio
                    id="radioNgay"
                    name="KyDongLaiMacDinh"
                    value={1}
                    dataType="number"
                    checked={data.KyDongLaiMacDinh === 1}
                    onChange={handleInputChange}
                    label="Ngày"
                  />
                )}
                {CustomRadio && data.KyDongLaiTuanEnabled && (
                  <CustomRadio
                    id="radioTuan"
                    name="KyDongLaiMacDinh"
                    value={4}
                    dataType="number"
                    checked={data.KyDongLaiMacDinh === 4}
                    onChange={handleInputChange}
                    label="Tuần"
                  />
                )}
                {CustomRadio && data.KyDongLaiThangEnabled && (
                  <CustomRadio
                    id="radioThang"
                    name="KyDongLaiMacDinh"
                    value={2}
                    dataType="number"
                    checked={data.KyDongLaiMacDinh === 2}
                    onChange={handleInputChange}
                    label="Tháng"
                  />
                )}
                {CustomRadio && data.KyDongLaiThangDinhKyEnabled && (
                  <CustomRadio
                    id="radioThangDinhKy"
                    name="KyDongLaiMacDinh"
                    value={3}
                    dataType="number"
                    checked={data.KyDongLaiMacDinh === 3}
                    onChange={handleInputChange}
                    label="Tháng định kỳ"
                  />
                )}
                <div className="mt-1">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Giá trị mặc định"
                    name="KyDongLaiTinChapCamDo"
                    value={data.KyDongLaiTinChapCamDo || ""}
                    onChange={handleInputChange}
                    disabled={!isAnyKyDongLaiEnabled}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="form-group row form-date-mm lai-suat-section">
        <label className="col-md-2 label-control">Lãi suất</label>
        <div className="col-md-10">
          {data.KyDongLaiNgayEnabled && (
            <React.Fragment key="lai-suat-ngay">
              <div className="interest-rate-group">
                <h4 className="interest-rate-title">Kỳ đóng lãi: Ngày</h4>
                <div className="d-flex config-container">
                  <div className="config-card flex-grow-1">
                    <div className="config-card-header">Danh sách</div>
                    <div className="config-card-body">
                      {CustomCheckbox && (
                        <CustomCheckbox
                          id="chkTrieuNgayNgay"
                          name="LaiTrieuNgay_NgayEnabled"
                          checked={data.LaiTrieuNgay_NgayEnabled}
                          onChange={handleInputChange}
                          label="Lãi/Triệu/Ngày"
                        />
                      )}
                      {CustomCheckbox && (
                        <CustomCheckbox
                          id="chkNgayNgay"
                          name="LaiNgay_NgayEnabled"
                          checked={data.LaiNgay_NgayEnabled}
                          onChange={handleInputChange}
                          label="Lãi ngày"
                        />
                      )}
                      {CustomCheckbox && (
                        <CustomCheckbox
                          id="chkThangNgay"
                          name="LaiThang_NgayEnabled"
                          checked={data.LaiThang_NgayEnabled}
                          onChange={handleInputChange}
                          label="Lãi tháng (%)"
                        />
                      )}
                      {CustomCheckbox && (
                        <CustomCheckbox
                          id="chkKyNgay"
                          name="LaiKy_NgayEnabled"
                          checked={data.LaiKy_NgayEnabled}
                          onChange={handleInputChange}
                          label="Lãi kỳ"
                        />
                      )}
                      {CustomCheckbox && (
                        <CustomCheckbox
                          id="chkPtKyNgay"
                          name="LaiPhanTramKy_NgayEnabled"
                          checked={data.LaiPhanTramKy_NgayEnabled}
                          onChange={handleInputChange}
                          label="Lãi % định kỳ"
                        />
                      )}
                    </div>
                  </div>
                  <div className="config-card flex-grow-1">
                    <div className="config-card-header">
                      Nhãn được chọn (Mặc định)
                    </div>
                    <div className="config-card-body">
                      {CustomRadio && data.LaiTrieuNgay_NgayEnabled && (
                        <CustomRadio
                          id="rdTrieuNgayNgay"
                          name="LaiSuatNgayMacDinh"
                          value={1}
                          dataType="number"
                          checked={data.LaiSuatNgayMacDinh === 1}
                          onChange={handleInputChange}
                          label="Lãi/Triệu/Ngày"
                        />
                      )}
                      {CustomRadio && data.LaiNgay_NgayEnabled && (
                        <CustomRadio
                          id="rdNgayNgay"
                          name="LaiSuatNgayMacDinh"
                          value={2}
                          dataType="number"
                          checked={data.LaiSuatNgayMacDinh === 2}
                          onChange={handleInputChange}
                          label="Lãi ngày"
                        />
                      )}
                      {CustomRadio && data.LaiThang_NgayEnabled && (
                        <CustomRadio
                          id="rdThangNgay"
                          name="LaiSuatNgayMacDinh"
                          value={3}
                          dataType="number"
                          checked={data.LaiSuatNgayMacDinh === 3}
                          onChange={handleInputChange}
                          label="Lãi tháng (%)"
                        />
                      )}
                      {CustomRadio && data.LaiKy_NgayEnabled && (
                        <CustomRadio
                          id="rdKyNgay"
                          name="LaiSuatNgayMacDinh"
                          value={4}
                          dataType="number"
                          checked={data.LaiSuatNgayMacDinh === 4}
                          onChange={handleInputChange}
                          label="Lãi kỳ"
                        />
                      )}
                      {CustomRadio && data.LaiPhanTramKy_NgayEnabled && (
                        <CustomRadio
                          id="rdPtKyNgay"
                          name="LaiSuatNgayMacDinh"
                          value={5}
                          dataType="number"
                          checked={data.LaiSuatNgayMacDinh === 5}
                          onChange={handleInputChange}
                          label="Lãi % định kỳ"
                        />
                      )}
                      <input
                        type="text"
                        className="form-control input-sm mt-1"
                        name="LaiSuatTinChapCamDoNgay"
                        value={data.LaiSuatTinChapCamDoNgay}
                        onChange={handleInputChange}
                        placeholder="Giá trị mặc định"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          {data.KyDongLaiTuanEnabled && (
            <React.Fragment key="lai-suat-tuan">
              <div className="interest-rate-group">
                <h4 className="interest-rate-title">Kỳ đóng lãi: Tuần</h4>
                <div className="d-flex config-container">
                  <div className="config-card flex-grow-1">
                    <div className="config-card-header">Danh sách</div>
                    <div className="config-card-body">
                      {CustomCheckbox && (
                        <CustomCheckbox
                          id="chkTuanTuan"
                          name="LaiTuan_TuanEnabled"
                          checked={data.LaiTuan_TuanEnabled}
                          onChange={handleInputChange}
                          label="Lãi tuần"
                        />
                      )}
                      {CustomCheckbox && (
                        <CustomCheckbox
                          id="chkPtTuan"
                          name="LaiPhanTram_TuanEnabled"
                          checked={data.LaiPhanTram_TuanEnabled}
                          onChange={handleInputChange}
                          label="Lãi % tuần"
                        />
                      )}
                    </div>
                  </div>
                  <div className="config-card flex-grow-1">
                    <div className="config-card-header">
                      Nhãn được chọn (Mặc định)
                    </div>
                    <div className="config-card-body">
                      {CustomRadio && data.LaiTuan_TuanEnabled && (
                        <CustomRadio
                          id="rdTuanTuan"
                          name="LaiSuatTuanMacDinh"
                          value={6}
                          dataType="number"
                          checked={data.LaiSuatTuanMacDinh === 6}
                          onChange={handleInputChange}
                          label="Lãi tuần"
                        />
                      )}
                      {CustomRadio && data.LaiPhanTram_TuanEnabled && (
                        <CustomRadio
                          id="rdPtTuan"
                          name="LaiSuatTuanMacDinh"
                          value={7}
                          dataType="number"
                          checked={data.LaiSuatTuanMacDinh === 7}
                          onChange={handleInputChange}
                          label="Lãi % tuần"
                        />
                      )}
                      <input
                        type="text"
                        className="form-control input-sm mt-1"
                        name="LaiSuatTinChapCamDoTuan"
                        value={data.LaiSuatTinChapCamDoTuan}
                        onChange={handleInputChange}
                        placeholder="Giá trị mặc định"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          {data.KyDongLaiThangEnabled && (
            <React.Fragment key="lai-suat-thang">
              <div className="interest-rate-group">
                <h4 className="interest-rate-title">Kỳ đóng lãi: Tháng</h4>
                <div className="d-flex config-container">
                  <div className="config-card flex-grow-1">
                    <div className="config-card-header">Danh sách</div>
                    <div className="config-card-body">
                      {CustomCheckbox && (
                        <CustomCheckbox
                          id="chkTrieuNgayThang"
                          name="LaiTrieuNgay_ThangEnabled"
                          checked={data.LaiTrieuNgay_ThangEnabled}
                          onChange={handleInputChange}
                          label="Lãi/Triệu/Ngày"
                        />
                      )}
                      {CustomCheckbox && (
                        <CustomCheckbox
                          id="chkNgayThang"
                          name="LaiNgay_ThangEnabled"
                          checked={data.LaiNgay_ThangEnabled}
                          onChange={handleInputChange}
                          label="Lãi ngày"
                        />
                      )}
                      {CustomCheckbox && (
                        <CustomCheckbox
                          id="chkThangThang"
                          name="LaiThang_ThangEnabled"
                          checked={data.LaiThang_ThangEnabled}
                          onChange={handleInputChange}
                          label="Lãi tháng (%)"
                        />
                      )}
                    </div>
                  </div>
                  <div className="config-card flex-grow-1">
                    <div className="config-card-header">
                      Nhãn được chọn (Mặc định)
                    </div>
                    <div className="config-card-body">
                      {CustomRadio && data.LaiTrieuNgay_ThangEnabled && (
                        <CustomRadio
                          id="rdTrieuNgayThang"
                          name="LaiSuatThangMacDinh"
                          value={1}
                          dataType="number"
                          checked={data.LaiSuatThangMacDinh === 1}
                          onChange={handleInputChange}
                          label="Lãi/Triệu/Ngày"
                        />
                      )}
                      {CustomRadio && data.LaiNgay_ThangEnabled && (
                        <CustomRadio
                          id="rdNgayThang"
                          name="LaiSuatThangMacDinh"
                          value={2}
                          dataType="number"
                          checked={data.LaiSuatThangMacDinh === 2}
                          onChange={handleInputChange}
                          label="Lãi ngày"
                        />
                      )}
                      {CustomRadio && data.LaiThang_ThangEnabled && (
                        <CustomRadio
                          id="rdThangThang"
                          name="LaiSuatThangMacDinh"
                          value={3}
                          dataType="number"
                          checked={data.LaiSuatThangMacDinh === 3}
                          onChange={handleInputChange}
                          label="Lãi tháng (%)"
                        />
                      )}
                      <input
                        type="text"
                        className="form-control input-sm mt-1"
                        name="LaiSuatTinChapCamDoThang"
                        value={data.LaiSuatTinChapCamDoThang}
                        onChange={handleInputChange}
                        placeholder="Giá trị mặc định"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>

      <div className="form-group row">
        <label className="col-md-2 label-control">Kiểu thanh toán</label>
        <div className="col-md-10">
          {CustomCheckbox && (
            <CustomCheckbox
              id="allBeforeAfter"
              name="AllBeforeAfterTinChapCamDo"
              checked={data.AllBeforeAfterTinChapCamDo}
              onChange={handleInputChange}
              label="Hiển thị tất cả (Chọn mặc định)"
            />
          )}
          <div className="d-flex align-items-center mt-2">
            {CustomRadio && (
              <CustomRadio
                id="traTruocCD"
                name="BeforeAfterTinChapCamDo"
                value={1}
                dataType="number"
                checked={data.BeforeAfterTinChapCamDo === 1}
                onChange={handleInputChange}
                label="Trước"
                className="mb-0 mr-3"
              />
            )}
            {CustomRadio && (
              <CustomRadio
                id="traSauCD"
                name="BeforeAfterTinChapCamDo"
                value={0}
                dataType="number"
                checked={data.BeforeAfterTinChapCamDo === 0}
                onChange={handleInputChange}
                label="Sau"
                className="mb-0"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
